<template>
	<div>
		<CCreatePersonFormDialog
			:show="showCreateDialog"
			:org-code="orgCode"
			:folder-id="folderId"
			:is-guest-list="isGuestList"
			@close="onDialogClose"
			@closed="$emit('closed')"
		/>
		<CUpsellDialog
			:show="showUpsell"
			:org-code="orgCode"
			:is-org-owner="isOrgOwner"
			feature="personfields"
			@close="onDialogClose"
			@closed="$emit('closed')"
		/>
	</div>
</template>

<script lang="ts">
	import { defineComponent, ref, watch } from 'vue';
	import CCreatePersonFormDialog from 'src/components/dialogs/CreatePersonFormDialog.vue';
	import CUpsellDialog from 'src/components/dialogs/UpsellDialog.vue';
	import { globalStore } from 'src/stores/global-store';
	import { checkRole } from 'src/views/admin/utils/role-check';
	import { ClientRole } from '@cognitoforms/types/server-types/core/services/client-role';
	import session from '@cognitoforms/api/services/session';

	export default defineComponent({
		components: {
			CCreatePersonFormDialog,
			CUpsellDialog
		},
		props: {
			show: { type: Boolean, required: true },
			orgCode: { type: String, required: true },
			folderId: { type: String, default: null },
			isGuestList: { type: Boolean, default: false }
		},
		emits: ['create', 'close', 'closed'],
		setup(props, { emit }) {
			const isOrgOwner = checkRole(ClientRole.Owner);
			const showCreateDialog = ref(false);
			const showUpsell = ref(false);

			watch(() => props.show, (isOpen) => {
				showCreateDialog.value = isOpen && (globalStore.organization.Plan.AllowLookups || session.value?.enabledFeatures?.PersonSubmissions);
				showUpsell.value = isOpen && !globalStore.organization.Plan.AllowLookups && !session.value?.enabledFeatures?.PersonSubmissions;
			}, { immediate: true });

			const onDialogClose = () => {
				showCreateDialog.value = false;
				showUpsell.value = false;
				emit('close');
			};

			return {
				isOrgOwner,
				showCreateDialog,
				showUpsell,
				onDialogClose
			};
		}
	});
</script>